import { Box, Card, Icon, Text } from '@nimbus-ds/components';

const PaymentMethodSkeleton = () => {
  return (
    <Box>
      <Card backgroundColor={'neutral-surface'}>
        <Card.Body>
          <Box width="100%" display="flex" gap="2" alignItems="flex-start">
            <Icon.Skeleton />
            <Box display="flex" flexDirection="column" gap="1">
              <Text.Skeleton width="200px" />
              <Text.Skeleton />
            </Box>
            <Box ml="auto" my="auto">
              <Icon.Skeleton />
            </Box>
          </Box>
        </Card.Body>
      </Card>
    </Box>
  );
};

export default PaymentMethodSkeleton;
